import cx from 'classnames';
import { XClose } from 'ethena-icons';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef } from 'react';
import css from './SidePanel.module.scss';

const SidePanelContext = React.createContext({ onClose: _.noop, show: false });

const SidePanel = ({ className, children, onClose, show }) => {
  return (
    <SidePanelContext.Provider value={{ onClose, show }}>
      <aside className={cx(css.sidePanel, className, { [css.expanded]: show })}>
        {children}
      </aside>
    </SidePanelContext.Provider>
  );
};

SidePanel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  show: PropTypes.bool,
};

const Header = ({ children }) => {
  const { onClose } = useContext(SidePanelContext);
  return (
    <header className={css.header}>
      <button className={css.closeButton}>
        <XClose onClick={onClose} />
      </button>
      {children}
    </header>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
};

const Title = (props) => <h1 className={css.title} {...props} />;

const Footer = (props) => <footer className={css.footer} {...props} />;

const Body = (props) => {
  const { show } = useContext(SidePanelContext);
  const bodyRef = useRef();

  useEffect(() => {
    if (show && bodyRef.current) {
      bodyRef.current.scrollTo({
        top: 0,
        behaviour: 'smooth',
      });
    }
  }, [show]);

  return <div className={css.body} {...props} ref={bodyRef} />;
};

SidePanel.Body = Body;
SidePanel.Header = Header;
SidePanel.Footer = Footer;
SidePanel.Title = Title;

export { SidePanel };
